<router-outlet></router-outlet>
<div class="app-shell">
  <div class="app-shell__header"></div>
  <div class="app-shell__dash"></div>
</div>